import { MENU_KEY_ROUTES } from "src/constants/modules";
import FlightsWrapper from "src/Modules/Flights/FlightsWrapper";
import {JourneyListing, JourneyDetails,JourneySearchPage} from "src/Modules/Flights";
import JourneyResult from "src/Modules/Flights/Pages/JourneyResult/JourneyResult";

export const flightsRoutes = {
  path: MENU_KEY_ROUTES["Travel"],
  element:<FlightsWrapper/>,
  children: [
    {
      index: true,
      element: <JourneySearchPage />,
    },
    {
      path: "tickets/:searchId",
      element: <JourneyListing />,
    },
    {
      path: "tickets/:searchId/ticket/:ticketId/:step?",
      element: <JourneyDetails />,
    },
    {
      path: "ticket-result/:ticketId",
      element: <JourneyResult />,
    },
  ],
};
